import useUsasClubFacilityLinksData from '../../../state/clubFacilityLinks/UseUsasClubFacilityLinksData';

import useBaseUsasClubData from '@usas/ui-web/state/clubBase/UseBaseUsasClubData';
import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';

const useClubFacilitiesAdd = () => {
  const { usasClubFacilityLinksState } = useUsasClubFacilityLinksData();
  const { baseUsasClubState } = useBaseUsasClubData();
  const { facilityState } = useFacilityData();

  return {
    usasClubFacilityLinksState,
    baseUsasClubState,
    facilityState
  };
};

export default useClubFacilitiesAdd;